export default {
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  SET_DY_OVERVIEW_INFOS: Symbol('SET_DY_OVERVIEW_INFOS'),
  SET_SYNC_RECORD: Symbol('SET_SYNC_RECORD'),
  DY_UPDATE_SEARCH_RES: Symbol('DY_UPDATE_SEARCH_RES'),
  DY_UPDATE_SEARCH_PARAM: Symbol('DY_UPDATE_SEARCH_PARAM'),
  SET_ROOM_TYPE_MATCH_LIST: Symbol('SET_ROOM_TYPE_MATCH_LIST'),
  SET_NOT_MATCHED_ROOM_LIST: Symbol('SET_NOT_MATCHED_ROOM_LIST'),
  SET_DY_DATE_RANGE_OPTION: Symbol('SET_DY_DATE_RANGE_OPTION'),
  SET_DY_DATE_RANGE_INDEX: Symbol('SET_DY_DATE_RANGE_INDEX'),
  SET_DY_ROOM_QUANTITY_LIST: Symbol('SET_DY_ROOM_QUANTITY_LIST'),
  SET_PRE_SALE_ROOM_TYPE_MATCH_LIST: Symbol('SET_PRE_SALE_ROOM_TYPE_MATCH_LIST'),
};
